/* eslint-disable @typescript-eslint/no-unsafe-member-access */
/* eslint-disable @typescript-eslint/no-unsafe-assignment */
/* eslint-disable @typescript-eslint/no-unsafe-call */
/* eslint-disable @typescript-eslint/no-unsafe-return */
/* eslint-disable import/no-cycle */
import React from 'react';
import { Box, Stack } from '@chakra-ui/core';
import { AnimatePresence } from 'framer-motion';
import { QuestionnaireTemplateStore } from '../../../store/questionnaireTemplateModel';
import { formElementSchema } from '../../schemas/formElement.schema';
import { QuestionBranchesContainer } from '../branch/QuestionBranchesContainer';
import { AnimatedWrapper } from '../../formBuilderComponents/withLayoutAnimation';
import { Branch, QUESTIONNAIRE_ELEMENT_TYPE } from '../../../questionnaireTemplate.enums';

const CONTENT_BOX_PROPS = {
  py: 3,
  px: 6,
  bg: 'white',
  borderBottomRadius: 'lg' as const,
};

const LOADING_FALLBACK_PROPS = { h: '40px', bg: 'gray.50', borderRadius: 'md' as const };

const LoadingFallback = React.memo(function LoadingFallback() {
  return <Box {...LOADING_FALLBACK_PROPS} />;
});

export const QuestionElementBody = React.memo(function QuestionElementBody({ id }: { id: string }) {
  const typeSelector = React.useCallback((state) => state.getElementValue(id, 'questionType'), [id]);
  const isExpandedSelector = React.useCallback((state) => state.getElementValue(id, 'expanded'), [id]);
  const configSelector = React.useCallback((state) => state.getElementValue(id, 'config'), [id]);

  const type = QuestionnaireTemplateStore.useStoreState<QUESTIONNAIRE_ELEMENT_TYPE>(typeSelector);
  const isExpanded = QuestionnaireTemplateStore.useStoreState<boolean>(isExpandedSelector);
  const config = QuestionnaireTemplateStore.useStoreState(configSelector);

  const schema = React.useMemo(() => formElementSchema[type] ?? null, [type]);
  const hasBranches = React.useMemo(() => schema?.branches && schema.branches.length > 0, [schema]);

  if (!schema) return null;

  const ElementComponent = schema.component;

  return (
    <>
      <AnimatePresence initial={false}>
        {isExpanded && (
          <AnimatedWrapper key={`${id}-body`}>
            <Stack {...CONTENT_BOX_PROPS} spacing={1}>
              <React.Suspense fallback={<LoadingFallback />}>
                <ElementComponent elementId={id} config={config} />
              </React.Suspense>
            </Stack>

            {hasBranches && !schema.isBranchDisabled && (
              <QuestionBranchesContainer id={id} branches={(schema.branches as Branch[])!} />
            )}
          </AnimatedWrapper>
        )}
      </AnimatePresence>
    </>
  );
});
